var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.personen,"item-key":"uid","item-class":_vm.tableRowClassName,"items-per-page":-1,"hide-default-footer":""},on:{"click:row":_vm.rowClick},scopedSlots:_vm._u([{key:"item.saldo",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm.format(item.saldo))+" ")]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }